import { useCallback, useEffect, useState } from "react";

/** Bootstrap-like modal exit duration (ms). */
export const MODAL_MOTION_MS = 300;

/**
 * Delayed close so CSS exit animation can finish before unmount.
 * @param {() => void} onClose
 * @param {{ duration?: number, open?: boolean }} [options]
 */
export function useModalMotion(onClose, options = {}) {
  const duration = options.duration ?? MODAL_MOTION_MS;
  const open = options.open;
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (open) setClosing(false);
  }, [open]);

  const requestClose = useCallback(() => {
    if (closing) return;
    setClosing(true);
  }, [closing]);

  useEffect(() => {
    if (!closing) return undefined;
    const timer = window.setTimeout(() => {
      onClose?.();
    }, duration);
    return () => window.clearTimeout(timer);
  }, [closing, duration, onClose]);

  return {
    closing,
    requestClose,
    motionClassName: closing ? " is-closing" : "",
  };
}
